import TrMin from './minDir.js';
import TrMax from './maxDir.js';

angular
    .module('channel.directives.validation', [])
    .directive('trMin', TrMin)
    .directive('trMax', TrMax);
